import { Component, Field } from '@contember/interface'

export const SolutionsPreview = Component(() => (
	<div>
		<Field field="name" />
	</div>
))
